/*
 *
 * RecordControlPanel reducer
 *
 */

import { fromJS } from "immutable"
import {
  GET_FILE_HISTORY_WATCHER,
  GET_FILE_HISTORY_SUCCESS,
  GET_FILE_HISTORY_FAILED,
} from "./constants"

export const initialState = fromJS({
  fileHistories: [],
  isLoadingFileHistores: undefined,
})

function recordControlPanelReducer(state = initialState, action) {
  switch (action.type) {
    case GET_FILE_HISTORY_WATCHER:
      return state
        .set("fileHistories", [])
        .set("isLoadingFileHistores", undefined)
    case GET_FILE_HISTORY_SUCCESS:
      return state
        .set("fileHistories", action.payload)
        .set("isLoadingFileHistores", false)
    case GET_FILE_HISTORY_FAILED:
      return state.set("fileHistories", []).set("isLoadingFileHistores", false)

    default:
      return state
  }
}

export default recordControlPanelReducer
